import React from 'react'
import { Tabs } from 'antd'
import { SettingOutlined } from '@ant-design/icons'
import { Layout } from '@surecompanies/core_components'
import Page from 'layouts/Page'
import PageWrapper from 'enrollment-platform/PageWrapper'
import BreadcrumbNav from 'enrollment-platform/components/Breadcrumbs'
import TestModeSettings from './pages/TestModeSettings/TestModeSettings'
import FeatureFlagSettings from './pages/FeatureFlagSettings/FeatureFlagSettings'

const { Content } = Layout

const tabs = [
  {
    key: 'test-mode',
    label: (
      <span>
        <SettingOutlined />
        Test Mode Setting
      </span>
    ),
    children: <TestModeSettings />,
  },
  {
    key: 'feature-flags',
    label: (
      <span>
        <SettingOutlined />
        Feature Flags
      </span>
    ),
    children: <FeatureFlagSettings />,
  },
]

export default function Settings() {
  return (
    <PageWrapper>
      <Page
        title="Settings"
        breadcrumb={<BreadcrumbNav items={[{ title: 'Settings' }]} />}
      >
        <Layout style={{ backgroundColor: '#f6f9fc' }}>
          <Content style={{ padding: '24px' }}>
            <Tabs items={tabs} />
          </Content>
        </Layout>
      </Page>
    </PageWrapper>
  )
}
